// extracted by mini-css-extract-plugin
export var header = "_a7-0";